<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb :lastItemName="tour.name" />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
            @click="showFormModal(null)"
            class="px-3 text-capitalize"
            variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد تیکت
        </b-button>
      </b-col>
    </b-row>
    <div v-if="tourDates">
      <div class="d-flex justify-content-between align-items-center">
        <per-page class="col-sm-12 col-md-3 col-lg-2" v-model="perPage" />
        <!-- <search
          ref="residencesSearchComponent"
          class="w-50"
          v-model="searchInput"
        /> -->
      </div>

      <b-table-simple responsive>
        <b-thead>
          <b-tr>
            <b-th>id</b-th>
            <b-th>عنوان</b-th>
            <b-th>زمان شروع</b-th>
            <b-th>زمان پایان</b-th>
            <b-th>ظرفیت</b-th>
            <b-th>هزینه</b-th>
            <b-th>کمسیون</b-th>
            <b-th>تاریخ ایجاد</b-th>
            <b-th>وضعیت</b-th>
            <b-th>عملیات</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="item in tourDates" :key="item.id">
            <b-td>{{ item.id }}</b-td>
            <b-td>{{ item.name }}</b-td>
            <b-td>{{
                new Date(item.start_date).toLocaleString("fa-IR").split(',')[0]

              }}</b-td>
            <b-td>{{
                new Date(item.return_date).toLocaleString("fa-IR").split(',')[0]
              }}</b-td>
            <b-td>{{item.max_people}} نفر</b-td>
            <b-td>{{ item.prices.normal_dayes }}</b-td>
            <b-td>
              <span v-if="item.commission_site>0">
                  {{numberFormat(item.commission_site)}} به ازای هر فرد
              </span>
              <span v-if="item.commission_host>0">
                   {{numberFormat(item.commission_host)}}  میزبان
              </span>
            </b-td>
            <b-td>
              {{
                new Date(item.created_at).toLocaleString("fa-IR", {
                  timeZone: "Iran",
                })
              }}
            </b-td>
            <b-td>
              <b-col
                  class="d-flex align-items-center pl-0"
                  :class="
                  item.status != 'active' ? 'text-danger' : 'text-success'
                "
              >
                {{ item.status == "active" ? "" : "غیر" }}فعال
              </b-col></b-td
            >
            <b-td>
              <b-col class="d-flex align-items-center">
                <!--                <b-button
                                    @click="showConfirmModal(item)"
                                    variant="flat-danger"
                                    class="font-weight-bolder"
                                >
                                  <feather-icon icon="Trash2Icon" size="20" />
                                </b-button>-->
                <b-button
                    @click="copyTourDate(item)"
                    variant="flat-primary"
                    class="font-weight-bolder mr-1"
                >
                  <feather-icon icon="CopyIcon" size="20" />
                </b-button>
                <b-button
                    @click="showFormModal(item)"
                    variant="flat-secondary"
                    class="font-weight-bolder"
                >
                  <feather-icon icon="Edit2Icon" size="20" />
                </b-button> </b-col
              ></b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <pagination
          ref="residencesPaginationComponent"
          v-model="page"
          :paginationData="paginationData"
      />
    </div>
    <b-sidebar
        width="80%"
        v-model="formModal"
        right
        backdrop
        shadow
        bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
                style="background-color: rgba(75, 75, 75, 0.12)"
                @click="formModal = false"
                variant="flat-dark"
                class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش تیکت" : "ایجاد تیکت" }}
            </h3>
          </div>
        </div>
      </template>

      <form-wizard
          color="#7367F0"
          :title="null"
          :subtitle="null"
          finish-button-text="Submit"
          back-button-text="قبلی"
          next-button-text="بعدی"
          class="steps-transparent mb-3"
          @on-complete="submitForm"
          ref="formWizard"
      >
        <!-- account detail tab -->
        <tab-content
            :before-change="beforeTab1Switch"
            title="اطلاعات اولیه"
            icon="feather icon-info"
            :lazy="true"
        >

          <b-container class="row">
            <b-form-group class="col-md-12">
              <label for="name" class="text-capitalize">
                عنوان تیکت : <span class="text-danger">*</span></label
              >
              <b-form-input
                  @input="removeErrors('name')"
                  id="name"
                  v-model="ticketInput.name"
                  type="text"
              />
              <ErrorMessage
                  errorType="name"
                  :errorMessages="errorMessage"
              ></ErrorMessage>
            </b-form-group>
            <b-col md="6">
              <b-form-group>
                <label for="host" class="text-capitalize">
                  انتخاب آژانس :<span class="text-danger">*</span></label
                >
                <v-select
                    id="host"
                    :components="{ OpenIndicator }"
                    class="bg-white"
                    :clearable="false"
                    v-model="ticketInput.agency_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="agencies"
                    label="title"
                    :reduce="(owner) => owner.id"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="host" class="text-capitalize">
                  انتخاب شرکت حمل و نقل /نوع حمل و نقل :<span class="text-danger">*</span></label
                >
                <v-select
                    id="host"
                    :components="{ OpenIndicator }"
                    class="bg-white"
                    :clearable="false"
                    v-model="ticketInput.transfer_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="transfers"
                    label="title"
                    :reduce="(owner) => owner.id"
                />
              </b-form-group>
            </b-col>
            <b-form-group class="col-md-6">
              <label for="residence_area" class="text-capitalize">
                نوع نور :<span class="text-danger">*</span>
              </label>
              <v-select
                  id="residence_area"
                  :components="{ OpenIndicator }"
                  class="bg-white"
                  :clearable="false"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="['عادی', 'اقسادی']"
                  v-model="ticketInput.trip_type"
              />
            </b-form-group>

            <b-form-group class="col-md-6">
              <label for="residence_area" class="text-capitalize">
                نوع حمل و نقل :<span class="text-danger">*</span>
              </label>
              <v-select
                  id="residence_area"
                  :components="{ OpenIndicator }"
                  class="bg-white"
                  :clearable="false"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="['هوایی','ریلی' ,'زمینی']"
                  v-model="ticketInput.transfer_type"
              />
            </b-form-group>

              <b-col cols="12" class="mb-2">
                <h4 class="text-muted">مبدا شروع تور از کجاست ؟</h4>
              </b-col>
              <b-col md="6">
                <b-form-group class="">
                  <label for="city_province" class="text-capitalize">
                    استان :</label
                  >
                  <v-select
                      id="city_province"
                      :components="{ OpenIndicator }"
                      class="bg-white"
                      :clearable="false"
                      v-model="ticketInput.state_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :reduce="(province) => province.id"
                      :options="provinces"
                      placeholder="برای جستجو تایپ کنید"
                      @input="getSelectedProvincesCity"
                  />
                  <!-- <ErrorMessage
                  errorType="state"
                  :errorMessages="errorMessage"
                ></ErrorMessage> -->
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group class="">
                  <label for="city_province" class="text-capitalize"> شهر :</label>
                  <v-select
                      :loading="showGettingCityLoading"
                      id="city_province"
                      :components="{ OpenIndicator }"
                      class="bg-white"
                      :clearable="false"
                      v-model="ticketInput.city_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :reduce="(city) => city.id"
                      :options="cities"
                      @input="getSelectedCityLocaion"
                      placeholder="برای جستجو تایپ کنید"
                  />
                  <!-- <ErrorMessage
                  errorType="city"
                  :errorMessages="errorMessage"
                ></ErrorMessage> -->
                </b-form-group>
              </b-col>







            <b-form-group class="mt-1 col-md-6">
              <label for="name" class="text-capitalize">
                شروع راس ساعت : <span class="text-danger">*</span></label
              >
              <!--          <b-form-input
                            v-model="ticketInput.start_time"
                            locale="fa"
                            :id="`type-${1}`"
                            type="time"
                        ></b-form-input>-->
              <date-picker v-model="ticketInput.start_time" type="time" />
            </b-form-group>
            <b-form-group class="mt-1 col-md-6">
              <label for="name" class="text-capitalize">
                پایان راس ساعت :<span class="text-danger">*</span>
              </label>
              <!--          <b-form-input
                            v-model="ticketInput.return_time"
                            locale="fa"
                            :id="`type-${2}`"
                            type="time"
                        ></b-form-input>-->
              <date-picker v-model="ticketInput.return_time" type="time" />
            </b-form-group>


            <b-form-group  class="col-md-6">
              <label for="name" class="text-capitalize"> روز شروع : </label>
              <b-form-input class="my-custom-editable-input1" type="text" />
              <date-picker
                  auto-submit
                  clearable
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jDD"
                  v-model="ticketInput.start_date"
                  custom-input=".my-custom-editable-input1"
              />
            </b-form-group>
            <b-form-group  class="col-md-6">
              <label for="name" class="text-capitalize"> روز پایان : </label>
              <b-form-input class="my-custom-editable-input2" type="text" />
              <date-picker
                  auto-submit
                  clearable
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jDD"
                  v-model="ticketInput.return_date"
                  custom-input=".my-custom-editable-input2"
              />
            </b-form-group>
            <b-form-group class="mt-1 col-md-12">
              <label for="name" class="text-capitalize">  حداکثر ظرفیت : </label>
              <b-form-input v-model="ticketInput.max_people" type="text" />
            </b-form-group>



            <label for="name" class="text-capitalize col-md-12 mt-2">
              هزینه ها :<span class="text-danger">*</span>
            </label>
            <b-form-group class="mt-1 col-md-6">
              <label for="name" class="text-capitalize"> ایام عادی : </label>
              <b-form-input :formatter="formatnumber" v-model="ticketInput.prices.normal_dayes" type="text" />
            </b-form-group>

            <!--        <b-form-group class="mt-1 col-md-6">
                      <label for="name" class="text-capitalize"> ایام آخر هفته : </label>
                      <b-form-input :formatter="formatnumber" v-model="ticketInput.prices.weekend_days" type="text" />
                    </b-form-group>-->

            <!--        <b-form-group class="mt-1 col-md-6">
                      <label for="name" class="text-capitalize"> ایام پیک : </label>
                      <b-form-input :formatter="formatnumber" v-model="ticketInput.prices.peack_days" type="text" />
                    </b-form-group>-->
            <b-form-group class="col-md-6">
              <b-form-checkbox
                  :label="ticketInput.prices.pricePerBaby.name"
                  v-model="ticketInput.prices.pricePerBaby.hasPrice"
              >
                هزینه به ازای هر نوزاد
              </b-form-checkbox>
              <b-form-input
                  lazy
                  :formatter="formatnumber"
                  :disabled="!ticketInput.prices.pricePerBaby.hasPrice"
                  v-model="ticketInput.prices.pricePerBaby.price"
              ></b-form-input>
            </b-form-group>
            <b-form-group class="col-md-6">
              <b-form-checkbox
                  :label="ticketInput.prices.pricePerAnimal.name"
                  v-model="ticketInput.prices.pricePerAnimal.hasPrice"
              >
                هزینه حیوانات</b-form-checkbox
              >
              <b-form-input
                  lazy
                  :formatter="formatnumber"
                  :disabled="!ticketInput.prices.pricePerAnimal.hasPrice"
                  v-model="ticketInput.prices.pricePerAnimal.price"
              ></b-form-input>
            </b-form-group>

            <b-form-group class="mt-1 col-md-12">
              <label for="name" class="text-capitalize">  مابقی هزینه بر اساس دلار : </label>
              <b-form-input  v-model="ticketInput.dollar_price" type="text" />
              <div v-if="ticketInput.dollar_price>0">{{numberFormat(ticketInput.dollar_price)}} دلار</div>
            </b-form-group>
            <b-col md="12" class="mt-2"></b-col>
            <b-col cols="6" md="6"> تخفیف به تعداد نفرات </b-col>
            <b-col cols="6" md="6" class="d-flex justify-content-end">
              <b-form-group label-for="discount" class="col-md-6">
                <!-- @change="value2 = $events" -->
                <b-form-spinbutton
                    name="discount"
                    id="sb-input"
                    v-model="discounts"
                    size="sm"
                    min="0"
                    max="10"
                    @input="removeDiscountBtnIsClicked = false,clickOnDiscountSpinBtn=true"
                ></b-form-spinbutton>
              </b-form-group>
            </b-col>

            <b-col
                md="12"
                v-for="(item, index) in ticketInput.prices_off"
                :key="'off_' + index"
            >
              <b-row>
                <b-form-group class="mt-1 col-6 col-sm-3">
                  <label for="name" class="text-capitalize">از : </label>
                  <b-input-group append="نفر">
                    <b-form-input v-model.number="item.from" type="number" />
                  </b-input-group>
                </b-form-group>

                <b-form-group class="mt-1 col-6 col-sm-3">
                  <label for="name" class="text-capitalize">تا : </label>
                  <b-input-group append="نفر">
                    <b-form-input v-model.number="item.to" type="number" />
                  </b-input-group>
                </b-form-group>

                <b-form-group class="mt-1 col-6 col-sm-3">
                  <label for="name" class="text-capitalize">تخفیف : </label>
                  <b-form-input v-model.number="item.discount" type="number" />
                </b-form-group>
                <b-form-group class="mt-1 col-4 col-sm-2">
                  <label for="name" class="text-capitalize">به صورت : </label>
                  <b-form-input disabled type="text" value="درصدی" />
                </b-form-group>
                <b-button
                    @click="removeDiscount(index)"
                    variant="flat-danger"
                    class="font-weight-bolder col-1 col-sm-1"
                >
                  <feather-icon icon="Trash2Icon" size="20" />
                </b-button>
              </b-row>
            </b-col>


            <b-col md="12" class="mt-2"> </b-col>
            <b-col md="12" class="mt-2"></b-col>
            <b-col cols="6" md="6"> خدمات ویژه </b-col>
            <b-col cols="6" md="6" class="d-flex justify-content-end">
              <b-form-group label-for="discount" class="col-md-6">
                <!-- @change="value2 = $events" -->
                <b-form-spinbutton
                    name="discount"
                    id="sb-input"
                    v-model="services"
                    size="sm"
                    min="0"
                    max="10"
                    @input="removeServicesBtnIsClicked = false,clickOnServiceSpinBtn=true"
                ></b-form-spinbutton>
              </b-form-group>
            </b-col>

            <b-col
                md="12"
                v-for="(item, index) in ticketInput.special_services"
                :key="'service_' + index"
            >
              <b-row>
                <b-form-group class="mt-1 col-6 col-sm-3">
                  <label for="name" class="text-capitalize">عنوان : </label>
                  <b-form-input v-model="item.name" type="text" />
                </b-form-group>

                <b-form-group class="mt-1 col-6 col-sm-3">
                  <label for="name" class="text-capitalize">هزینه : </label>
                  <b-form-input v-model.number="item.price" type="number" />
                </b-form-group>

                <b-form-group
                    class="col-6 mt-1 col-sm-3"
                    label="شیوه ارائه"
                    label-for="min-night-input"
                >
                  <b-form-select
                      v-model="item.method"
                      :options="methodss"
                      value-field="value"
                      text-field="text"
                  ></b-form-select>
                </b-form-group>
                <b-form-group class="mt-1 col-4 col-sm-2">
                  <b-form-checkbox
                      v-model="item.perPerson"
                      :id="`perperson_${index}`"
                      class="font-sm"
                  ><small> به ازای هر نفر</small>
                  </b-form-checkbox>
                </b-form-group>
                <b-button
                    @click="removeService(index)"
                    variant="flat-danger"
                    class="font-weight-bolder col-1 col-sm-1"
                >
                  <feather-icon icon="Trash2Icon" size="20" />
                </b-button>
              </b-row>
            </b-col>



            <b-form-group class="mt-1 col-md-12">
              <label for="name" class="text-capitalize">  کمیسیون دریافتی سایت به ازای هر فرد : </label>
              <b-form-input  v-model="ticketInput.commission_site" type="text" />
              <div v-if="ticketInput.commission_site>0">{{numberFormat(ticketInput.commission_site)}} تومان</div>
            </b-form-group>

            <b-form-group class="mt-1 col-md-12">
              <label for="name" class="text-capitalize">  کمیسیون میزبان : </label>
              <b-form-input  v-model="ticketInput.commission_host" type="text" />
              <div v-if="ticketInput.commission_host>0">{{numberFormat(ticketInput.commission_host)}} تومان</div>
            </b-form-group>



            <b-form-group class="mt-1 col-md-12" v-slot="{ ariaDescribedby }">
              <label for="province_status" class="text-capitalize"> وضعیت : </label>
              <b-form-checkbox
                  v-model="ticketInput.status"
                  :aria-describedby="ariaDescribedby"
                  value="active"
                  @input="removeErrors('status')"
              >فعال</b-form-checkbox
              >
              <b-form-checkbox
                  v-model="ticketInput.status"
                  :aria-describedby="ariaDescribedby"
                  value="inactive"
                  @input="removeErrors('status')"
              >پیش نویس</b-form-checkbox
              >
              <ErrorMessage
                  errorType="status"
                  :errorMessages="errorMessage"
              ></ErrorMessage>
            </b-form-group>
          </b-container>
        </tab-content>

        <!-- personal details -->
        <!-- personal details -->
        <!-- address -->
        <tab-content
            title="اطلاعات تکمیلی"
            icon="feather icon-map-pin"
            :lazy="true"
        >
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">اطلاعات تکمیلی</h5>
            </b-col>
          </b-row>
          <hr />
<!--
          <b-row>
            <b-col md="12">
              <h6 for="name1" class="text-capitalize">
                تور شامل چه مواردی میشود:<span class="text-danger">*</span>
              </h6>
            </b-col>
          </b-row>

          <div>
            {{ticketInput.include}}
            <div v-for="item in formItems" :key="item.id">
              <b-row class="mb-2">
                <b-col md="8">
                  <b-form-input v-model="item.value" placeholder="اطلاعات را وارد کنید..." />
                </b-col>
                <b-col md="4">
                  <b-button @click="removeItem(item.id)" variant="danger" size="sm">
                    حذف
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <b-row>
              <b-col md="12">
                <b-button @click="addAndSaveItem" variant="primary">
                  + افزودن
                </b-button>
              </b-col>
            </b-row>
          </div>




          <b-row>
            <b-col cols="8" class="mt-2">
              <h6>
                تور شامل چه مواردی نمیشود
                <span class="text-danger">*</span>
              </h6>
            </b-col>
          </b-row>

          <div>
            {{ticketInput.exclude}}
            <div v-for="item in formExcludeItems" :key="item.id">
              <b-row class="mb-2">
                <b-col md="8">
                  <b-form-input v-model="item.value" placeholder="اطلاعات را وارد کنید..." />
                </b-col>
                <b-col md="4">
                  <b-button @click="removeExcludeItem(item.id)" variant="danger" size="sm">
                    حذف
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <b-row>
              <b-col md="12">
                <b-button @click="addAndSaveExcludeItem" variant="primary">
                  + افزودن
                </b-button>
              </b-col>
            </b-row>
          </div>
-->


                  <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">برنامه سفر</h5>
          </b-col>
          <b-col md="12">
            <h6 for="name1" class="text-capitalize">
              تور شامل چه مواردی میشود:<span class="text-danger">*</span>
            </h6>
          </b-col>
        </b-row>
        <b-row
          v-for="(item, index) in ticketInput.include"
          :key="'includes_' + index"
        >
          <b-col key="key-question-name" md="8">
            <b-form-group>
              <b-form-input
                lazy
                key="question_name"
                v-model="ticketInput.include[index]"
                id="question_name"
                placeholder="پاوربانک..."
              />
            </b-form-group>
          </b-col>

          <b-button
            @click="removeIncludes(index)"
            variant="flat-danger"
            class="font-weight-bolder"
          >
            <feather-icon icon="Trash2Icon" size="20" />
          </b-button>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-button @click="newInclude"
              >افزودن <feather-icon icon="PlusIcon" size="20"
            /></b-button>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="8" class="mt-2">
            <h6>
              تور شامل چه مواردی نمیشود
              <span class="text-danger">*</span>
            </h6>
          </b-col>
        </b-row>
        <b-row
          v-for="(item, index) in ticketInput.exclude"
          :key="'excludes_' + index"
        >
          <b-col key="key-question-name" md="8">
            <b-form-group>
              <b-form-input
                lazy
                key="question_name"
                v-model="ticketInput.exclude[index]"
                id="question_name"
                placeholder="سس..."
              />
            </b-form-group>
          </b-col>

          <b-button
            @click="removeExcludes(index)"
            variant="flat-danger"
            class="font-weight-bolder"
          >
            <feather-icon icon="Trash2Icon" size="20" />
          </b-button>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-button @click="newExclude"
              >افزودن <feather-icon icon="PlusIcon" size="20"
            /></b-button>
          </b-col>
        </b-row>
        <hr />

          <hr />
          <b-row>
            <b-col class="mt-2" md="12"><h6>محل اقامتگاه / هتل تور</h6></b-col>
          </b-row>
          <div>
            <b-row
                v-for="(space, index) in ticketInput.spaces"
                :key="'spaces_' + index"
                :class="index % 2 == 0 ? 'custom-bg' : 'bg-white'"
                class="mb-2 p-2"
            >
              <b-col md="4">
                <b-form-group>
                  <label for="name1" class="text-capitalize">
                    آپلود تصویر شاخص محل اقامت تور:<span class="text-danger">*</span>
                  </label>
                  <b-overlay :show="space.imageUploderLoading" rounded="sm">
                    <div
                        id="my-strictly-unique-vue-upload-multiple-image"
                        style="display: flex; justify-content: center"
                    >
                      <div
                          v-if="space.image.url"
                          class="w-100 position-relative"
                      >
                        <img
                            width="100%"
                            :src="$http.defaults.fileUrl + '/uploads/' + space.image.url"
                        />
                        <b-button
                            @click="removeSpaceImage(index, space.image.id)"
                            pill
                            style="left: 5px"
                            variant="danger"
                            class="font-weight-bolder position-absolute"
                            title="حذف عکس"
                        >
                          <feather-icon icon="Trash2Icon" size="20" />
                        </b-button>
                      </div>
                      <vue-upload-multiple-image
                          v-else
                          @upload-success="(formData, i, fileList) => uploadSpaceImageSuccess(formData, i, fileList, index)"
                          @before-remove="beforeRemove"
                          @edit-image="(formData, i, fileList) => uploadSpaceImageSuccess(formData, i, fileList, index)"
                          :data-images="[]"
                          :idUpload="`myIdUpload` + index"
                          editUpload="myIdEdit"
                          :multiple="false"
                          browseText="انتخاب فایل"
                          markIsPrimaryText="انتخاب به عنوان عکس اصلی"
                          primaryText="عکس پیش فرض"
                          dragText="عکس ها را اینجا رها کنید"
                          popupText="این عکس به عنوان عکس اصلی انتخاب شده است"
                      ></vue-upload-multiple-image>
                    </div>
                  </b-overlay>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="name1" class="text-capitalize">عنوان محل اقامتگاه تور:<span class="text-danger">*</span></label>
                  <b-form-input
                      lazy
                      v-model="space.title"
                      placeholder="عنوان  محل اقامتگاه تور"
                  />
                </b-form-group>
                <b-form-group>
                  <label for="name1" class="text-capitalize">توضحیات مختصر در مورد محل اقامتگاه تور:<span class="text-danger">*</span></label>
                  <b-form-input
                      lazy
                      v-model="space.description"
                      placeholder="توضحیات مختصر   محل اقامتگاه تور"
                  />
                </b-form-group>
                <b-form-group>
                  <label for="name1" class="text-capitalize">آدرس url در مورد محل اقامتگاه تور:<span class="text-danger">*</span></label>
                  <b-form-input
                      lazy
                      v-model="space.url"
                      placeholder="آدرس url در مورد محل اقامتگاه تور:"
                  />
                </b-form-group>
                <b-form-group>
                  <label for="name1" class="text-capitalize">مدت شب  اقامت محل تور:<span class="text-danger">*</span></label>
                  <b-form-input
                      lazy
                      v-model="space.duration"
                      placeholder="مدت شب اقامت در محل تور:"
                  />
                </b-form-group>
                <b-form-group>
                  <label for="name1" class="text-capitalize">چند ستاره :<span class="text-danger">*</span></label>
                  <b-form-input
                      lazy
                      v-model="space.star"
                      placeholder="چند ستاره:"
                  />
                </b-form-group>
                <b-form-group>
                  <label for="name1" class="text-capitalize">تعداد تخت اتاق :<span class="text-danger">*</span></label>
                  <b-form-input
                      lazy
                      v-model="space.room"
                      placeholder="تعداد تخت اتاق:"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  @click="removeSpaces(index)"
                  variant="flat-danger"
                  class="font-weight-bolder"
              >
                <feather-icon icon="Trash2Icon" size="40" />
              </b-button>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-button variant="outline-primary" @click="newSpace" block>
                  افزودن اقامتگاه <feather-icon icon="PlusIcon" size="20" />
                </b-button>
              </b-col>
            </b-row>
          </div>
        </tab-content>

        <tab-content title="برنامه سفر" icon="feather icon-map-pin" :lazy="true">
          <b-row>
            <b-col class="mt-2" md="12"><h6>برنامه تور</h6></b-col>

            <b-col
                :class="index % 2 == 0 ? 'custom-bg' : 'bg-white'"
                v-for="(value, index) in ticketInput.days"
                :key="'days_' + index"
                md="12"
            >
              <b-col md="12">
                <b-form-group>
                  <label for="name1" class="text-capitalize"
                  >عنوان روز :<span class="text-danger">*</span></label
                  >
                  <b-form-input
                      lazy
                      key="name1"
                      v-model="value.dayTitle"
                      id="name"
                      placeholder="روز اول ..."
                  />
                </b-form-group>
              </b-col>
              <b-row>
                <b-col
                    md="6"
                    v-for="(dayItem, dayItemIndex) in value.spaces"
                    :key="'value_spaces_' + dayItemIndex"
                    class="position-relative"
                >
                  <b-row class="pt-2">
                    <b-col md="6">
                      <label :for="`myIdUpload2` + index" class="text-capitalize">
                        آپلود تصویر مراحل تور:<span class="text-danger"
                      >*</span
                      ></label
                      >
                      <b-overlay
                          :show="dayItem.imageUploaderLoading"
                          rounded="sm"
                      >
                        <div
                            v-if="dayItem.image.url && editMode"
                            class="w-100 position-relative"
                        >
                          <img
                              width="100%"
                              :src="
                            $http.defaults.fileUrl +
                            '/uploads/' +
                            dayItem.image.url
                          "
                          />
                          <b-button
                              @click="removeDaysImage(index, dayItem.image.id, dayItemIndex)"
                              pill
                              style="left: 5px"
                              variant="danger"
                              class="font-weight-bolder position-absolute"
                              title="حذف عکس"
                          >
                            <feather-icon icon="Trash2Icon" size="20" />
                          </b-button>
                        </div>
                        <vue-upload-multiple-image
                            v-else
                            @upload-success="
                          (formData, i, fileList) =>
                            uploadDaySpaceImageSuccess(
                              formData,
                              i,
                              fileList,
                              dayItemIndex,
                              index
                            )
                        "
                            @before-remove="beforeRemove"
                            @edit-image="
                          (formData, i, fileList) =>
                            uploadDaySpaceImageSuccess(
                              formData,
                              i,
                              fileList,
                              dayItemIndex,
                              index
                            )
                        "
                            :data-images="images"
                            :idUpload="`myIdUpload2` + dayItemIndex + `_` + index"
                            editUpload="myIdEdit"
                            :multiple="false"
                            browseText="انتخاب فایل"
                            markIsPrimaryText="انتخاب به عنوان عکس اصلی"
                            primaryText="عکس پیش فرض"
                            dragText="عکس ها را اینجا رها کنید"
                            popupText="این عکس به عنوان عکس اصلی انتخاب شده است"
                        />
                      </b-overlay>
                    </b-col>
                    <b-col md="6">
                      <b-form-group>
                        <label for="name1" class="text-capitalize"
                        >عنوان محل :<span class="text-danger">*</span></label
                        >
                        <b-form-input
                            lazy
                            key="name1"
                            v-model="dayItem.title"
                            id="name"
                            placeholder="عنوان محل "
                        />
                      </b-form-group>
                      <b-form-group>
                        <label for="name1" class="text-capitalize"
                        >توضحیات مختصر در مورد محل تور:<span class="text-danger"
                        >*</span
                        ></label
                        >
                        <b-form-input
                            lazy
                            key="name1"
                            v-model="dayItem.description"
                            id="name"
                            placeholder="توضحیات مختصر تور"
                        />
                      </b-form-group>
                      <b-form-group>
                        <label for="name1" class="text-capitalize"
                        >آدرس url در مورد تور:<span class="text-danger"
                        >*</span
                        ></label
                        >
                        <b-form-input
                            lazy
                            key="name1"
                            v-model="dayItem.blog_url"
                            id="name"
                            placeholder="آدرس url در مورد تور:"
                        />
                      </b-form-group>
                      <b-form-group>
                        <label for="name1" class="text-capitalize"
                        >مدت زمان اجرای محل تور:<span class="text-danger"
                        >*</span
                        ></label
                        >
                        <b-form-input
                            lazy
                            key="name1"
                            v-model="dayItem.duration"
                            id="name"
                            placeholder="مدت زمان اجرای محل تور:"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-button
                      @click="removeDaySpace(dayItemIndex, index)"
                      variant="flat-danger"
                      style="top: 0; left: 0"
                      class="font-weight-bolder position-absolute"
                  >
                    <feather-icon icon="Trash2Icon" size="20" />
                  </b-button>
                </b-col>
              </b-row>
              <b-col md="3">
                <b-button @click="newDayspace(index)"
                >افزودن محل <feather-icon icon="PlusIcon" size="20"
                /></b-button>
              </b-col>
              <hr />
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <b-button
                  class="w-100"
                  @click="newDay"
                  block
                  variant="outline-primary"
              >افزودن روز <feather-icon icon="PlusIcon" size="20"
              /></b-button> </b-col
            ></b-row>

        </tab-content>



      </form-wizard>








      <!--      <template #footer>
              <div class="d-flex align-items-center justify-content-end px-2 py-1">
                <b-button
                    class="text-capitalize mr-2"
                    @click="formModal = false"
                    variant="outline-dark"
                >
                  {{ $t("cancel") }}
                </b-button>
                <b-button variant="primary" @click="submitForm()">
                  <div v-if="submitLoading" class="px-1">
                    <b-spinner small style="width: 1.3rem; height: 1.3rem" />
                    <span class="sr-only">Loading...</span>
                  </div>
                  <span v-else class="text-capitalize">
                    {{ $t("submit") }}
                  </span>
                </b-button>
              </div>
            </template>-->
    </b-sidebar>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormCheckbox,
  BTableSimple,
  BThead,
  BTbody,
  BFormSelect,
  BTr,
  BTh,
  BTd,
  BFormCheckboxGroup,
  BFormSpinbutton,
  BTime,
  BInputGroup, BOverlay,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import ErrorMessage from "@/components/ErrorMessage.vue";
import FilePicker from "@/components/FilePicker.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import {latLng} from "leaflet";
export default {
  components: {
    BOverlay,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    BFormSelect,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    ErrorMessage,
    BFormCheckbox,
    FilePicker,
    BTableSimple,
    FormWizard,
    TabContent,
    ToastificationContent,
    VueUploadMultipleImage,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BFormCheckboxGroup,
    BFormSpinbutton,
    BTime,
    datePicker: VuePersianDatetimePicker,
    BInputGroup,
  },
  data() {
    return {
      dayOptions: [
        "شنبه",
        "یکشنبه",
        "دوشنبه",
        "سه شنبه",
        "چهارشنبه",
        "پنجشنبه",
        "جمعه",
      ],
      optionsShow: [
        { value: null, text: "انتخاب نمایش در ص اصلی" },
        { value: "0", text: "عدم نمایش در صفحه اصلی" },
        { value: "1", text: "نمایش در صفحه اصلی" },
      ],
      tour: {},
      iconImageurl: "",
      errorMessage: {},
      perPage: 10,
      page: 1,
      buildings: [],
      tourDates: [],
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      agencies: [],
      transfers: [],
      tableHeadings: [
        {
          title: "تصویر آیکن",
          slug: "image_icon",
          sortable: false,
        },
        {
          title: "آیکن",
          slug: "icon",
          sortable: false,
        },
        {
          title: "عنوان",
          slug: "name",
          sortable: true,
        },
        {
          title: "توضیحات",
          slug: "description",
          sortable: true,
        },
        {
          title: "نمایش در صفحه",
          slug: "show_index_page",
          sortable: true,
        },
        {
          title: "تاریخ ایجاد",
          slug: "created_at",
          sortable: true,
        },

        {
          title: "وضعیت",
          slug: "status",
          sortable: false,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      companies: [],
      provinces: [],
      cities: [],
      imageUploadPercentage: 0,
      images: [],
      showGettingCityLoading: false,
      imagesHelper: [],
      thirdImagesHelper: [],
      buildingsCancelToken: undefined,
      formItems: [],
      formExcludeItems: [],
      ticketInput: {
        id: "",
        name: "",
        agency_id: "",
        state_id: "",
        city_id: "",
        transfer_id: "",
        slug: "",
        description: "",
        trip_type: "",
        transfer_type: "",
        status: "",
        commission_site: "",
        dollar_price: "",
        commission_host: "",
        image: null,
        icon: "",
        show_index_page: "",
        is_recurring_period: false,
        recurring_period: [],
        prices: {
          priceType: "pricePerKillometers",
          peack_days: null,
          normal_dayes: null,
          weekend_days: null,
          pricePerBaby: {
            name: "هزینه به ازای هر نوزاد",
            price: "",
            hasPrice: false,
          },
          pricePerAnimal: {
            name: "هزینه حیوانات",
            price: "",
            hasPrice: false,
          },
          start_date: null,
          return_date: null,
        },
        special_services: [],
        prices_off: [],
        days: {
          dayTitle: "",
          spaces: [
            {
              title: "",
              description: "",
              image: "",
              blog_url: "",
              duration: "",
            },
          ],
        },
        include: [],
        exclude: [],
        spaces: [],
        execution_type: "",
        gender: "",
        ticket_type: "",
      },
      methodss: [
        { value: "daily", text: "روزانه" },
        { value: "oneTime", text: "یکبار" },
      ],
      editMode: false,
      formModal: false,
      submitLoading: false,
      services: 0,
      removeServicesBtnIsClicked: false,
      clickOnServiceSpinBtn:false,
      discounts: 0,
      removeDiscountBtnIsClicked: false,
      clickOnDiscountSpinBtn:false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getTickets();
    this.getAgencies();
    this.getTransfers();
    this.getExperience();
    this.getProvinces();

  },
  watch: {
    searchInput(value) {
      this.page = 1;
      this.getTickets();
    },
    perPage(value) {
      this.page = 1;
      this.getTickets();
    },
    page(value) {
      this.getTickets();
    },
    discounts(newVal, oldVal) {
      if (this.removeDiscountBtnIsClicked|| !this.clickOnDiscountSpinBtn) {
        this.clickOnDiscountSpinBtn=true
        return;
      }
      if (newVal == 0) {
        this.ticketInput.prices_off = [];
      } else if (newVal < oldVal) {
        this.ticketInput.prices_off.splice(-1);
      } else if (newVal > oldVal) {
        this.ticketInput.prices_off.push({ from: "", to: "", discount: 0 });
      }
    },
    services(newVal, oldVal) {
      if (this.removeServicesBtnIsClicked || !this.clickOnServiceSpinBtn) {
        this.clickOnServiceSpinBtn=true
        return;
      }
      if (newVal == 0) {
        this.ticketInput.special_services = [];
      } else if (newVal < oldVal) {
        this.ticketInput.special_services.splice(-1);
      } else if (newVal > oldVal) {
        this.ticketInput.special_services.push({
          name: "",
          price: "",
          method: 0,
          perPerson: false,
        });
      }
    },

  },
  computed: {

  },
  methods: {
    getSelectedProvincesCity(provinceId) {
      this.showGettingCityLoading = true;
      this.getCityByProvinceId(provinceId);
    },
    getSelectedCityLocaion(value){
      var index= this.cities.findIndex(item=>item.id==value)
    },
    async getCityByProvinceId(provinceId) {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        paginate: false,
        // search: this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: `/admin/cities/${provinceId}`,
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.cities = data.data;
            this.paginationData = data.meta;
            this.showGettingCityLoading = false;
            if (!this.editMode) {
              this.ticketInput.city_id = this.cities[0]["id"];
            }
          })
          .catch((err) => {
            console.log(err);
            this.showGettingCityLoading = false;
          });
    },
    getProvinces(search, loading) {
      if (typeof this.provincesCancelToken != typeof undefined) {
        this.provincesCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.provincesCancelToken = this.$http.CancelToken.source();

      let data = {
        paginate: false,
        //  this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/states",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.provinces = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },

    getAgencies(search, loading) {

      let data = {
        paginate: false,
        //  this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/tours/agencies",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.agencies = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },

    getTransfers(search, loading) {
      let data = {
        paginate: false,

        //  this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/tours/transfer_companies",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.transfers = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },


    addAndSaveItem() {
      const newItem = { id: Date.now(), value: '' };
      this.formItems.push(newItem);
      this.ticketInput.include = this.formItems.map(item => item.value);
    },
    removeItem(id) {
      this.formItems = this.formItems.filter(item => item.id !== id);
      this.ticketInput.include = this.formItems.map(item => item.value);
    },
    addAndSaveExcludeItem() {
      const newItem = { id: Date.now(), value: '' };
      this.formExcludeItems.push(newItem);
      this.ticketInput.exclude = this.formExcludeItems.map(item => item.value);
    },
    removeExcludeItem(id) {
      this.formExcludeItems = this.formExcludeItems.filter(item => item.id !== id);
      this.ticketInput.exclude = this.formExcludeItems.map(item => item.value);
    },
    beforeTab1Switch() {
      return true;
    },
    beforeTab2Switch() {
      return true;
    },
    beforeTab3Switch() {
      return true;
    },

    removeSpaceImage(index, imageId) {
      this.ticketInput.spaces[index].image = { url: null, id: null };
    },
    removeDaysImage(dayIndex, imageId, spaceIndex) {
      if (
          this.ticketInput.days &&
          this.ticketInput.days[dayIndex] &&
          this.ticketInput.days[dayIndex].spaces &&
          this.ticketInput.days[dayIndex].spaces[spaceIndex]
      ) {
        this.$set(
            this.ticketInput.days[dayIndex].spaces[spaceIndex],
            'image',
            { url: null, id: null }
        );
      }
    },
    uploadSpaceImageSuccess(formData, index, fileList, k) {
      console.log("data", formData, index, fileList, k);
      // console.log('formData.keys()', formData.values())
      for (const value of formData.values()) {
        this.imagesHelper.push(value);
        console.log(this.imagesHelper);
      }

      let toUploadformData = new FormData();
      this.imagesHelper.forEach((image, index) => {
        toUploadformData.append(`file`, image);
      });
      const requestData = {
        method: "post",
        url: `/admin/medias`,
        data: toUploadformData,
        // config: config,
      };
      var vm = this;
      this.ticketInput.spaces[k].imageUploderLoading = true;
      this.$http(requestData, formData)
          .then((response) => {
            console.log(response);
            vm.ticketInput.spaces[k].imageUploderLoading = false;

            vm.ticketInput.spaces[k]["image"]["url"] =
                response.data.data.files.original;
            vm.ticketInput.spaces[k]["image"]["id"] = response.data.data.id;

            // return true;
          })
          .catch((err) => {
            console.log("falseeee");
            this.ticketInput.spaces[k].imageUploderLoading = false;
            // return false;
          });
    },

    uploadDaySpaceImageSuccess(formData, index, fileList, dayItemIndex, k) {
      for (const value of formData.values()) {
        this.imagesHelper.push(value);
        console.log(this.imagesHelper);
      }

      let toUploadformData = new FormData();
      this.imagesHelper.forEach((image, index) => {
        toUploadformData.append(`file`, image);
      });

      const requestData = {
        method: "post",
        url: `/admin/medias`,
        data: toUploadformData,
        // config: config,
      };
      var vm = this;
      this.ticketInput.days[k].spaces[dayItemIndex].imageUploaderLoading = true;
      this.$http(requestData, formData)
          .then((response) => {
            console.log(response);
            vm.ticketInput.days[k].spaces[
                dayItemIndex
                ].imageUploaderLoading = false;

            vm.ticketInput.days[k].spaces[dayItemIndex]["image"]["url"] =
                response.data.data.files.original;
            vm.ticketInput.days[k].spaces[dayItemIndex]["image"]["id"] =
                response.data.data.id;

            // return true;
          })
          .catch((err) => {
            console.log("falseeee");
            vm.ticketInput.days[k].spaces[
                dayItemIndex
                ].imageUploaderLoading = false;
            // return false;
          });
      // this.$toast({
      //   component: ToastificationContent,
      //   props: {
      //     title: "Form Submitted",
      //     icon: "EditIcon",
      //     variant: "success",
      //   },
      // });

      // Upload image api
      // axios.post('http://your-url-upload', formData).then(response => {
      //   console.log(response)
      // })
    },

    beforeRemove(index, done, fileList) {
      console.log("index", index, fileList);
      var r = confirm("remove image");
      if (r == true) {
        done();

        this.imagesHelper.splice(index, 1);
        console.log(this.imagesHelper);
      } else {
      }
    },
    editImage(formData, index, fileList) {
      console.log("edit data", formData, index, fileList);
      for (const value of formData.values()) {
        this.imagesHelper[index] = value;
        console.log(this.imagesHelper);
      }
    },
    markIsPrimary(index, fileList) {
      console.log("index", index);

      const fromIndex = index;
      const toIndex = 0;

      const element = this.imagesHelper.splice(fromIndex, 1)[0];

      this.imagesHelper.splice(toIndex, 0, element);
      console.log("this.imagesHelper", this.imagesHelper);
    },
    numberFormat(number) {
      return  new Intl.NumberFormat().format(number)
    },


    newSpace() {
      if (!Array.isArray(this.ticketInput.spaces)) {
        this.$set(this.ticketInput, 'spaces', []);
      }
      this.ticketInput.spaces.push({
        image: { url: "", id: "" },
        title: "",
        description: "",
        url: "",
        duration: "",
        imageUploderLoading: false,
      });
    },
    newDay() {
      if (!Array.isArray(this.ticketInput.days)) {
        this.$set(this.ticketInput, 'days', []);
      }
      this.ticketInput.days.push({
        dayTitle: "",
        spaces: [
          {
            title: "",
            description: "",
            image: { url: "", id: "" },
            blog_url: "",
            duration: "",
            imageUploaderLoading: false,
          },
        ],
      });




    },

    newDayspace(index) {
      this.ticketInput.days[index].spaces.push({
        title: "",
        description: "",
        image: { url: "", id: "" },
        blog_url: "",
        duration: "",
        imageUploaderLoading: false,
      });
    },

    newInclude() {
      this.ticketInput.include.push("");
    },
    newExclude() {
      this.ticketInput.exclude.push("");
    },


    removeExcludes(index) {
      this.ticketInput.exclude.splice(index, 1);
    },
    removeIncludes(index) {
      this.ticketInput.include.splice(index, 1);
    },
    removeSpaces(index) {
      this.ticketInput.spaces.splice(index, 1);
    },
    removeDaySpace(dayItemIndex, index) {
      this.ticketInput.days[index].spaces.splice(dayItemIndex, 1);
    },

    inputIconImageFile(file) {
      this.removeErrors("image");
      this.ticketInput.image = file;
    },
    removeErrors(data) {
      if (
          typeof this.errorMessage[data] !== "undefined" &&
          this.errorMessage[data].length > 0
      ) {
        // this.errorMessage[data][0]="salllam"
        delete this.errorMessage[data];
        this.errorMessage = Object.assign(
            {},
            this.errorMessage,
            this.errorMessage
        );
        console.log(data, this.errorMessage);
      }
    },
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getTickets();
    },

    async getTickets() {
      const requestData = {
        method: "get",
        url: "/admin/tours/tour_dates/tour/"+this.$route.params.id+"?paginate=true",
        // params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.tourDates = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    showConfirmModal(tourDate) {
      this.$bvModal
          .msgBoxConfirm(
              `آیا از حذف بلیط مطمئن هستید ؟  : ${tourDate.name}.`,
              {
                title: this.$t("Please Confirm"),
                size: "sm",
                okVariant: "primary",
                okTitle: this.$t("Yes"),
                cancelTitle: this.$t("No"),
                cancelVariant: "outline-secondary",
                hideHeaderClose: false,
                centered: true,
              }
          )
          .then(async (confirmed) => {
            if (confirmed) {
              let residenceIndex = 0;
              this.tourDates = await this.tourDates.filter(
                  (residenceItem, index) => {
                    if (residenceItem.id == tourDate.id) {
                      residenceIndex = index;
                    }
                    return residenceItem.id !== tourDate.id;
                  }
              );

              const requestData = {
                method: "delete",
                url: `/admin/experiences/experience_dates/${tourDate.id}`,
              };
              this.$http(requestData)
                  .then((response) => {
                    this.$bvToast.toast(
                        `بلیط: ${tourDate.name}  با موفقیت حذف شد.`,
                        {
                          title: this.$t("Done"),
                          variant: "success",
                          solid: true,
                        }
                    );
                  })
                  .catch((err) => {
                    let message = this.$t("Unable to delete!");
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                    )
                      message = err.response.data.message;
                    this.$bvToast.toast(message, {
                      title: this.$t("Error"),
                      variant: "danger",
                      solid: true,
                    });
                    this.tourDates.splice(residenceIndex, 0, tourDate);
                  });
            }
          });
    },
    showFormModal(tourDate) {
      this.clickOnDiscountSpinBtn=false
      this.clickOnServiceSpinBtn=false
      if (tourDate) {
        (this.ticketInput = {
          id: tourDate.id,
          name: tourDate.name,
          agency_id: tourDate.agency_id,
          state_id: tourDate.state_id,
          city_id: tourDate.city_id,
          transfer_id: tourDate.transfer_id,
          status: tourDate.status,
          trip_type: tourDate.trip_type,
          transfer_type: tourDate.transfer_type,
          is_recurring_period: tourDate.is_recurring_period,
          recurring_period: tourDate.recurring_period,
          commission_site:tourDate.commission_site,
          dollar_price:tourDate.dollar_price,
          commission_host:tourDate.commission_host,
          prices: tourDate.prices,
          days: tourDate.days,
          include: tourDate.include,
          exclude: tourDate.exclude,
          spaces: tourDate.spaces,
          special_services: tourDate.special_services,
          prices_off: tourDate.prices_off,
          execution_type: tourDate.execution_type,
          gender: tourDate.gender,
          ticket_type: tourDate.ticket_type,

          max_people:tourDate.max_people,
          start_time:tourDate.start_time,
          start_date: tourDate.start_date,
          return_time: tourDate.return_time,
          return_date:tourDate.return_date
        }),
            /*      (this.discounts = tourDate.prices_off.length),
                  (this.services = tourDate.special_services.length),*/
            (this.editMode = true);
      } else {
        (this.discounts = 0),
            (this.ticketInput = {
              name: "",
              agency_id: "",
              transfer_id: "",
              state_id: "",
              city_id: "",
              status: "",
              trip_type: "",
              transfer_type: "",
              dollar_price: "",
              is_recurring_period: false,
              recurring_period: [],
              prices: {

                priceType: "pricePerKillometers",
                peack_days: null,
                normal_dayes: null,
                weekend_days: null,
                pricePerBaby: {
                  name: "هزینه به ازای هر نوزاد",
                  price: "",
                  hasPrice: false,
                },
                pricePerAnimal: {
                  name: "هزینه حیوانات",
                  price: "",
                  hasPrice: false,
                },

              },
              prices_off: [],
              days: [],
              include: [],
              exclude: [],
              spaces: [],
              special_services: [],
              execution_type: "",
              gender: "",
              ticket_type: "",
              max_people:"",
              commission_site:"",
              commission_host:"",
              start_time:null,
              start_date: null,
              return_time: null,
              return_date:null
            }),
            (this.editMode = false);
      }
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;
      let errorMessage = null;
      if (!errorMessage && !this.ticketInput.name) {
        errorMessage = "لطفا نام بلیط  را وارد کنید";
      }

      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;

      const requestData = {
        method: this.editMode ? "post" : "post",
        url: this.editMode
            ? `/admin/tours/tour_dates/update/${this.ticketInput.id}`
            : `/admin/tours/tour_dates`,
        data: { ...this.ticketInput, tour_id: this.$route.params.id },
      };

      this.$http(requestData)
          .then((response) => {
            let message = " بلیط با موفقیت اضافه شد";
            if (this.editMode) message = " بلیط با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });

            this.submitLoading = false;
            this.formModal = false;
            this.getTickets();
          })
          .catch((err) => {
            let message = "خطا در ایجاد  بلیط";
            if (this.editMode) message = "خطا در ویرایش  بلیط";
            if (
                err.response &&
                err.response.data &&
                err.response.data.response &&
                err.response.data.response.message
            )
              message = err.response.data.response.message;
            if (
                err.response &&
                err.response.data &&
                err.response.data.response &&
                err.response.data.response.meta &&
                err.response.data.response.meta.errors
            )
              this.errorMessage = err.response.data.response.meta.errors;
            console.log("this.errorMessage", this.errorMessage);

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });
    },


    copyTourDate(tourDate) {
      const requestData = {
        method: 'post',
        url: `/admin/tours/tour_dates/copy/${tourDate.id}`,
      };

      this.$http(requestData)
          .then((response) => {
            this.$bvToast.toast('تیکت با موفقیت کپی شد', {
              title: 'انجام شد',
              variant: 'success',
              solid: true,
            });
            this.getTickets();
          })
          .catch((err) => {
            this.$bvToast.toast('خطا در کپی تیکت', {
              title: 'خطا',
              variant: 'danger',
              solid: true,
            });
          });
    },

    getExperience() {
      const requestData = {
        method: "get",
        url: `/admin/tours/${this.$route.params.id}`,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;

            this.tour = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    formatnumber(newValue) {
      const result = newValue
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return result;
    },
    removeDiscount(index) {
      this.removeDiscountBtnIsClicked = true;
      this.ticketInput.prices_off.splice(index, 1);
      this.discounts = this.discounts - 1;
    },
    removeService(index) {
      this.removeServicesBtnIsClicked = true;
      this.ticketInput.special_services.splice(index, 1);
      this.services = this.services - 1;
    },


  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>